import React, { useMemo, useState } from 'react';
import { AncientOne, GameState, Investigator } from '../api';
import { InvestigatorMarker } from './InvestigatorMarker';
import { InvestigatorDisplay } from './InvestigatorDisplay';
import { AncientOneDisplay } from './AncientOneDisplay';
import { PlayerHeader } from './PlayersList';

interface FinalBattlePanelProps {
  ancientOne?: AncientOne;
  investigators?: Investigator[];
  highlightedInvestigators?: string[];
  gameState?: GameState;
  language?: string;
  onExecuteAction: (actionId: string) => void;
  currentInvestigator?: Investigator;
}

export const FinalBattlePanel: React.FC<FinalBattlePanelProps> = ({
  ancientOne,
  investigators = [],
  highlightedInvestigators = [],
  language,
  gameState,
  onExecuteAction,
  currentInvestigator,
}) => {
  const [openInvestigatorName, setOpenInvestigatorName] = useState<string | null>(null);
  const investigatorMap = useMemo(
    () => (investigators || []).reduce<Record<string, Investigator>>((acc, inv) => {
      acc[inv.name] = inv;
      return acc;
    }, {}),
    [investigators]
  );
  const openInvestigator = openInvestigatorName && investigatorMap && investigatorMap[openInvestigatorName];

  return (
    <div className="final-battle-ancient-wrapper">
      <div className="final-battle-ancient-heading">Final Battle</div>
      <div className="final-battle-ancient-content">
        <AncientOneDisplay
          ancientOne={ancientOne}
          isFinalBattle
          responsive
          ancientOneDamageDealt={gameState?.ancientOneDamageDealt}
          ancientOneDamageThreshold={gameState?.ancientOneDamageThreshold}
        />
        {investigators.length > 0 && (
          <div className="final-battle-investigators">
            {investigators.map((inv, idx) => (
              <InvestigatorMarker
                key={inv.name}
                investigator={inv}
                idx={idx}
                size={64}
                scale={1}
                highlighted={!!currentInvestigator ? currentInvestigator?.name === inv.name : highlightedInvestigators.includes(inv.name)}
                offsetByIndex={false}
                onClick={() => setOpenInvestigatorName(inv.name)}
              />
            ))}
          </div>
        )}
      </div>

      {openInvestigator && (
        <div
          className="investigator-popup-overlay"
          onClick={() => setOpenInvestigatorName(null)}
        >
          <div
            className="investigator-popup"
            onClick={(e) => e.stopPropagation()}
          >
            {!!gameState && <PlayerHeader gameState={gameState} investigator={openInvestigator} />}
            <InvestigatorDisplay gameState={gameState}
              investigator={investigatorMap[openInvestigator.name] ?? openInvestigator}
              showStats
              language={language}
              availableActions={gameState?.availableActions || []}
              onExecuteAction={onExecuteAction}
            />
          </div>
        </div>
      )}
    </div>
  );
};
